import { FaGraduationCap, FaHistory, FaServer } from "react-icons/fa";
import { GiLaptop } from "react-icons/gi";
import mernStatic from "../src/assets/img/mern1.png";
import mernGif from "../src/assets/img/mern+.gif";
import covidStatic from "../src/assets/img/covid191.png";
import covidGif from "../src/assets/img/covid19.gif";
import messageboardStatic from "../src/assets/img/messageboard.png";
import messageboardGif from "../src/assets/img/messageboard.gif";
import netflixStatic from "../src/assets/img/netflix.png";
import netflixGif from "../src/assets/img/netflix.gif";
import cartGif from "../src/assets/img/shoppingCart.gif";
import cartStatic from "../src/assets/img/ShoppingCart.png";
import newsGif from "../src/assets/img/news.gif";
import newsStatic from "../src/assets/img/news.png";

export const resumeData = [
  {
    header: "Education",
    icon: <FaGraduationCap />,
    title: [
      {
        headerDescription:
          "Full Stack Web Development at DCI Digital Career Institute gGmbH",
        detail:
          "Accomplishing a one-year-full-time training, covering Frontend and Backend. Completing multiple practical projects to practice programming skills, and taking German lessons as part of the course",
        date: "2021 – 2022",
      },
      {
        headerDescription: "Bachelor's degree in English Literature",
        detail: "Damascus University",
        date: "2005 – 2010",
      },
    ],
  },

  {
    header: "Work History",
    icon: <FaHistory />,
    title: [
      {
        headerDescription: "Software Developer at “SECANDA Systems AG“",
        detail:
          "Building and evolving web applications with Angular, TypeScript and Vue.js, including a large e-charging platform. Developing REST APIs and C# backend code, working with Angular Signals, Reactive Forms and TanStack Query, migrating UI components from DevExtreme to Optimus UI, and writing unit tests alongside code reviews and refactoring.",
        date: "08/2025 – now",
      },
      {
        headerDescription: "Developer at “Jservice“",
        detail:
          "Built an automated skinning test tool with Python, Express.js and MongoDB, automating screen capture, template overlay and image comparison, and integrated it into existing test and development processes.",
        date: "08/2023 – 03/2025",
      },
      {
        headerDescription:
          "Laravel Developer and API Integration internship at “e-Commeleon“",
        detail:
          "Web development with PHP and Laravel, integration of third-party APIs, and support with databases, debugging and testing.",
        date: "01/2023 – 03/2023",
      },

      {
        headerDescription: "IT Support Specialist at “Saudi Arabia Embassy“",
        detail:
          "Troubleshooting technical issues, setting up devices and supporting administrative and technical processes.",
        date: "2019 – 2020",
      },
      {
        headerDescription:
          "IT Support and System Maintenance at “Fannat Company“",
        detail:
          "Maintaining the IT infrastructure and systems to keep daily business operations running smoothly.",
        date: "2010 – 2015",
      },
    ],
  },

  {
    header: "Frontend",
    icon: <GiLaptop />,
    title: [
      {
        skill: "TypeScript",
        level: 5.4,
      },
      {
        skill: "JavaScript",
        level: 5.5,
      },
      {
        skill: "Angular, RxJS & Signals",
        level: 5.2,
      },
      {
        skill: "React & Next.js",
        level: 5.3,
      },
      {
        skill: "Vue.js & Nuxt",
        level: 4.6,
      },
      {
        skill: "HTML & CSS / SCSS",
        level: 5.3,
      },
      {
        skill: "Tailwind CSS & Bootstrap",
        level: 5,
      },
      {
        skill: "DevExtreme & Optimus UI",
        level: 4.5,
      },
    ],
  },

  {
    header: "Backend & Tools",
    icon: <FaServer />,
    title: [
      {
        skill: "C#",
        level: 4.3,
      },
      {
        skill: "Node.js & Express.js",
        level: 4.9,
      },
      {
        skill: "REST APIs & TanStack Query",
        level: 5.2,
      },
      {
        skill: "PHP & Laravel",
        level: 4.4,
      },
      {
        skill: "Python",
        level: 4.2,
      },
      {
        skill: "MongoDB & MySQL",
        level: 4.6,
      },
      {
        skill: "Vitest & Unit Testing",
        level: 4.5,
      },
      {
        skill: "Git, GitLab CI & Docker",
        level: 4.8,
      },
    ],
  },
];

export const projects = [
  {
    id: 1,
    title: "MERN+",
    github: "https://github.com/altinawiwaseem/swm-final-project",
    link: "https://mernplus.onrender.com/",
    detail:
      "Quiz App is a full-stack web application that allows users to take quizzes, solve code challenges, view results, and track progress",
    imgStatic: mernStatic,
    imgGif: mernGif,
  },
  {
    id: 2,
    title: "News Aggregator",
    github: "https://github.com/altinawiwaseem/news-aggregator",
    link: "https://github.com/altinawiwaseem/news-aggregator",
    detail:
      "React, Laravel Dockerized web application that aggregates news articles from three API sources, allows users to search for news  using various methods, and save their search preferences in a preferences dashboard.",
    imgStatic: newsStatic,
    imgGif: newsGif,
  },
  {
    id: 3,
    title: "Covid-19 Tracker ",
    github: "https://github.com/altinawiwaseem/COVID-19-Traker-react-app",
    link: "https://covid-19-traker-react-6mpkbu00r-altinawiwaseem.vercel.app/",
    detail:
      "App to track Covid-19 cases around the world spotting cases on the map and give daily and total deaths, recovers and cases.",
    imgStatic: covidStatic,
    imgGif: covidGif,
  },
  {
    id: 4,
    title: "Message Board",
    github: "https://github.com/altinawiwaseem/message-Board",
    link: "https://github.com/altinawiwaseem/message-Board",
    detail:
      "Fullstack application which serves as an online messageboard. include a full REST API, with user data stored in a MongoDB server.",
    imgStatic: messageboardStatic,
    imgGif: messageboardGif,
  },
  {
    id: 5,
    title: "PHP Shopping Cart ",
    github: "https://github.com/altinawiwaseem/php-shopping-cart",
    link: "https://github.com/altinawiwaseem/php-shopping-cart",
    detail: "PHP shopping cart using relational database mysql",
    imgStatic: cartStatic,
    imgGif: cartGif,
  },
  {
    id: 6,
    title: "Netflix Clone",
    github: "https://github.com/altinawiwaseem/NETFLIX_CLONE",
    link: "https://netflix-clone-react-proj-91d29.web.app/",
    detail: "Netflix clone project to mimic Netflix website",
    imgStatic: netflixStatic,
    imgGif: netflixGif,
  },
];

export const aboutMe = `Hello! I'm Waseem, a full-stack developer who fell in love with programming after discovering its power to turn ideas into working products. I build and evolve modern web applications with Angular, TypeScript, Vue.js and React on the frontend, and Node.js, Express and C# with REST APIs on the backend.\nI enjoy digging into existing codebases, analysing how things work, implementing new requirements and improving code and application architecture along the way. Writing unit tests, debugging and taking part in code reviews are a natural part of how I work.\nHaving worked across a wide range of technologies, I get productive in unfamiliar projects and codebases quickly. If you'd like to learn more about my skills and experience, please feel free to get in touch with me.`;
